export default __webpack_public_path__ + "static/media/modal_img.fdd01736.png";